import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import styles from '@assets/scss/components/info-list.module.scss'
import descStyle from './style.module.scss'
import { convertDt24h, dateCheck } from '@shared-submodule/utils'

import MyImage from '@shared/components/myImage'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import placeholderFlag from 'assets/images/placeholder/team-placeholder.svg'
import CustomLink from '@shared/components/customLink'
import { TwitterImg, WikipediaImg, InstaImg, FbImage } from '@shared/components/ctIcons'
import { useRouter } from 'next/router'

const PlayerInfo = ({ data }) => {
  const router = useRouter()
  const [showMore, setShowMore] = useState(true)
  const handleDesc = () => {
    // window.scrollTo(0, 0)
    setShowMore(!showMore)
  }
  useEffect(() => {
    setShowMore(true)
  }, [router.asPath])

  return (
    <>
      <h3 className="small-head">{'Player Info'}</h3>
      <row>
        <section className={`${styles.playerInfo}`}>
          <div className={`${styles.list} ${descStyle.containerInfo} font-semi mb-4 common-box p-3 overflow-hidden`}>
            {(data?.sFullName || data?.sShortName) && (
              <>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Full Name
                    </p>
                    <p className="mb-0">{data?.sFullName || data?.sShortName || '-'}</p>
                  </div>
                </div>
              </>
            )}

            {data?.sCountryFull && (
              <>
                <div className="w-100 d-sm-none d-block"></div>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Nationality
                    </p>
                    <p className="mb-0">{data?.sCountryFull || '-'}</p>
                  </div>
                </div>
              </>
            )}
            {data?.sBirthPlace && (
              <>
                <div className="w-100 d-sm-none d-block"></div>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Birth Place
                    </p>
                    <p className="mb-0">{data?.sBirthPlace || '-'}</p>
                  </div>
                </div>
              </>
            )}
            {data?.dBirthDate && (
              <>
                <div className="w-100 d-sm-none d-block"></div>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Birth Date
                    </p>
                    <p className="mb-0">{data?.dBirthDate ? convertDt24h(dateCheck(data?.dBirthDate)) : '-'}</p>
                  </div>
                </div>
              </>
            )}
            {data?.sBattingStyle && (
              <>
                <div className="w-100 d-sm-none d-block"></div>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Batting Style
                    </p>
                    <p className="mb-0">{data?.sBattingStyle?.replaceAll('_', ' ')}</p>
                  </div>
                </div>
              </>
            )}
            {data?.sBowlingStyle && (
              <>
                <div className="w-100 d-sm-none d-block"></div>
                <div className={`${descStyle.box} col-md-4 col-12`}>
                  <div className={`${styles.item} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0`}>
                      Bowling Style
                    </p>
                    <p className="mb-0">{data?.sBowlingStyle?.replaceAll('_', ' ') || '-'}</p>
                  </div>
                </div>
              </>
            )}
            {data?.aMajorTeams && data.aMajorTeams.length !== 0 && (
              <div className={` ${descStyle.borderTop} ${styles.item} d-flex w-100`}>
                <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0 d-flex align-items-center`}>Teams</p>
                {/* <row> */}
                <div className="w-100 d-flex flex-wrap gap-3">
                  {data?.aMajorTeams?.map(teams => (
                    <div className={`${descStyle.marginRight} d-flex`} key={teams.sTitle}>
                      <div className={`${descStyle.icon}`}>
                        <MyImage
                          src={teams?.oImg?.sUrl ? `${S3_PREFIX}${teams?.oImg?.sUrl}` : placeholderFlag}
                          placeholderImage={placeholderFlag}
                          alt={teams?.oImg?.sTitle || 'Team Icon'}
                          layout="responsive"
                          width="32"
                          height="32"
                          sizes="(max-width: 767px) 32px, (max-width: 991px) 32px, (max-width: 1190px) 200px, 32px"
                        />
                      </div>
                      <div className={`${descStyle.teamTitle}`}>{teams.sTitle}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {(data?.oSocialMedia?.oFacebook?.sHandle ||
              data?.oSocialMedia?.oInstagram?.sHandle ||
              data?.oSocialMedia?.oWikipedia?.sHandle ||
              data?.oSocialMedia?.oTwitter?.sHandle) && (
              <div className={` ${descStyle.borderTop} ${styles.item} d-flex w-100`}>
                <p className={`${styles.label} ${descStyle.textLightMuted} mb-0 flex-shrink-0 d-flex align-items-center`}>Socials</p>
                <div className="w-100 d-flex flex-wrap gap-3">
                  {data?.oSocialMedia?.oWikipedia?.sHandle && (
                    <div className={`${descStyle.socialPill} d-flex`}>
                      <div className={`${descStyle.socialIcon}`}>
                        <WikipediaImg />
                      </div>
                      <div className={`${descStyle.socialTag}`}>
                        <CustomLink target="_blank" href={`${data?.oSocialMedia?.oWikipedia?.sUrl}`}>
                          <a target="_blank">{data?.oSocialMedia?.oWikipedia?.sHandle}</a>
                        </CustomLink>
                      </div>
                    </div>
                  )}
                  {data?.oSocialMedia?.oInstagram?.sHandle && (
                    <div className={`${descStyle.socialPill} d-flex`}>
                      <div className={`${descStyle.socialIcon}`}>
                        <InstaImg />
                      </div>
                      <div className={`${descStyle.socialTag}`}>
                        <CustomLink target="_blank" href={`${data?.oSocialMedia?.oInstagram?.sUrl}`}>
                          <a target="_blank">{data?.oSocialMedia?.oInstagram?.sHandle}</a>
                        </CustomLink>
                      </div>
                    </div>
                  )}
                  {data?.oSocialMedia?.oFacebook?.sHandle && (
                    <div className={`${descStyle.socialPill} d-flex`}>
                      <div className={`${descStyle.socialIcon}`}>
                        <FbImage />
                      </div>
                      <div className={`${descStyle.socialTag}`}>
                        <CustomLink target="_blank" href={`${data?.oSocialMedia?.oFacebook?.sUrl}`}>
                          <a target="_blank">{data?.oSocialMedia?.oFacebook?.sHandle}</a>
                        </CustomLink>
                      </div>
                    </div>
                  )}
                  {data?.oSocialMedia?.oTwitter?.sHandle && (
                    <div className={`${descStyle.socialPill} d-flex`}>
                      <div className={`${descStyle.socialIcon}`}>
                        <TwitterImg />
                        {/* <MyImage
                            src={twitter}
                            alt='Twitter'
                            layout="responsive"
                            width="32"
                            height="32"
                          /> */}
                      </div>
                      <div className={`${descStyle.socialTag}`}>
                        <CustomLink target="_blank" href={data?.oSocialMedia?.oTwitter?.sUrl}>
                          <a target="_blank">{data?.oSocialMedia?.oTwitter?.sHandle}</a>
                        </CustomLink>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {data?.bIsCustomPlayerDescription && (
              <row>
                <div className={`${descStyle.borderTop}`}>
                  <div className={`${styles.item} ${styles.list}  ${descStyle.dBlock} d-flex`}>
                    <p className={`${styles.label} ${descStyle.textLightMuted} ${descStyle.w_100} mb-0 flex-shrink-0 text-muted mb-2`}>
                      About
                    </p>
                    <div>
                      <div className={`${descStyle.aboutCntr} ${descStyle.pl_0}  ${showMore ? descStyle.readMore : ''} fw-bold`}>
                        {showMore ? (
                          <div dangerouslySetInnerHTML={{ __html: data?.sCustomPlayerDescription.slice(0, 400) }} />
                        ) : (
                          <div dangerouslySetInnerHTML={{ __html: data?.sCustomPlayerDescription }} />
                        )}
                      </div>
                      <button type="button" className={`btn btn-link ${descStyle.readBtn} fw-bold`} onClick={handleDesc}>
                        {showMore ? '...Read More' : '...Read Less'}
                      </button>
                    </div>
                  </div>
                </div>
              </row>
            )}
          </div>
        </section>
      </row>
    </>
  )
}

PlayerInfo.propTypes = {
  data: PropTypes.object
}

export default PlayerInfo
